exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-link[data-v-58b540e3] {\n  color: #6c757d;\n  text-decoration: none;\n}\n.btn-link[data-v-58b540e3]:hover {\n  color: #21272d;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58b540e3","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/contracts/ContractsCard.vue
// module id = rQkN
// module chunks = 1